import { Component, OnInit } from '@angular/core';
import { HttpLoaderService } from '@tymes4-shared';
import { ActivatedRoute, Params } from '@angular/router';
import {OrderDetailsService, OrderDetailsView} from '../../../shared/api';

@Component({
    selector: 'app-order-confirm',
    templateUrl: './order-confirm.component.html',
    styleUrls: ['./order-confirm.component.scss'],
    standalone: false
})
export class OrderConfirmComponent implements OnInit {

  orderId: number = -1;
  order: any = null;

  constructor(
    private route: ActivatedRoute,
    private apploader: HttpLoaderService,
    private orderService: OrderDetailsService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {

      if (params.id) {
        this.orderId = +params.id;
        this.loadOrder(this.orderId);
      }
    });
  }

  loadOrder(orderId: number) {
    this.apploader.open();

    this.orderService.getOrderDetails(orderId, true).subscribe((details: OrderDetailsView) => {
      this.order = details;
      this.apploader.close();
    });
  }

}
